var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{attrs:{"height":"auto","id":"home_header"}},[_c('root-header')],1),_c('router-view',{key:_vm.$route.fullPath}),_c('root-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }